const ACTION_LABELS = {
  'user:create': 'Usuario creado',
  'user:login_success': 'Inicio de sesión',
  'user:login_failed': 'Inicio de sesión fallido',
  'user:login_locked': 'Cuenta bloqueada',
  'user:permissions_change': 'Cambio de permisos',
  'user:role_change': 'Cambio de rol',
  'user:deactivate': 'Usuario desactivado',
  'user:activate': 'Usuario activado',
  'paciente:delete': 'Paciente eliminado',
  'prueba:create': 'Prueba creada',
  'prueba:update': 'Prueba actualizada',
  'prueba:delete': 'Prueba eliminada',
  'prueba:import': 'Importación de pruebas',
};

const ACTION_COLORS = {
  'user:create': 'success',
  'user:login_success': 'success',
  'user:activate': 'success',
  'user:login_failed': 'warning',
  'user:permissions_change': 'warning',
  'user:role_change': 'warning',
  'user:login_locked': 'error',
  'user:deactivate': 'error',
  'paciente:delete': 'error',
  'prueba:create': 'success',
  'prueba:update': 'info',
  'prueba:delete': 'error',
  'prueba:import': 'info',
};

const ENTITY_TYPE_LABELS = {
  user: 'Usuario',
  paciente: 'Paciente',
  entrevista: 'Entrevista',
  otros: 'Otras pruebas',
  capacidad_funcional: 'Capacidad funcional',
  valoracion_funcional: 'Valoración funcional',
  medidas_antropometricas: 'Medidas antropométricas',
  cuestionario: 'Cuestionario',
  encoder: 'Encoder (5STS)',
};

export const ENTITY_TYPES = Object.keys(ENTITY_TYPE_LABELS);

export const getActionLabel = (action) => ACTION_LABELS[action] || action;

export const getActionColor = (action) => ACTION_COLORS[action] || 'default';

export const getEntityTypeLabel = (entityType) => (entityType ? (ENTITY_TYPE_LABELS[entityType] || entityType) : '—');
